import React from 'react'
import { Portlet, Table } from '_zari/core'
import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'
import TiposDeSocioConstant from 'constants/tiposDeSocio'
import ImportarSociosModal from './modals/importar'
import { ZariContext } from '_zari/context'

const portletBreadcrumbs = [{ name: 'Socios' }]

const tableHeaderRows = [
  {
    label: 'TIPO',
    width: 110
  },
  {
    label: 'TIPO DOC.',
    width: 145
  },
  {
    label: 'NRO. DOC.',
    width: 115,
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  {
    label: 'RAZÓN SOCIAL',
    width: 70,
    filter: {
      type: 'text',
      name: 'razSoc'
    }
  },
  {
    label: '',
    width: 60
  }
]

const ListaSociosPage = ({ history }) => {
  const _zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const [mostrarImportarSocios, setMostrarImportarSocios] = React.useState(false)

  const clickEditarHandler = React.useCallback(({ _id }) => history.push(`/${CodigosTransaccionesConstant.SOCIOS_NUEVO}/${_id}`), [history])

  const clickNuevoHandler = React.useCallback(() => history.push(`/${CodigosTransaccionesConstant.SOCIOS_NUEVO}`), [history])

  const clickImportarSocios = React.useCallback(() => {
    setMostrarImportarSocios(true)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Socios' breadcrumbs={portletBreadcrumbs} buttons={[
          { name: 'Nuevo', onClick: clickNuevoHandler },
          { name: 'Importar Socios', onClick: clickImportarSocios }/*,
          { name: 'Exportar Socios', onClick: clickExportarSocios }*/
        ]} />
        <Portlet.Body>
          <Table.ServerSide
            useFilters={true}
            useNest={true}
            useInve={true}
            ref={tablaRef}
            url='/socios'
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.tipo ? TiposDeSocioConstant.__dictionary[row.tipo].nombre : '--'}</Table.Cell>
                <Table.Cell>
                  {row.tipoDocumento ? TiposDeDocumentoIdentificacionConstant.__dictionary[row.tipoDocumento].nombreCorto : '--'}
                </Table.Cell>
                <Table.Cell>{row.numeroDocumento}</Table.Cell>
                <Table.Cell>{row.razonSocial}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditarHandler({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarImportarSocios && (
        <ImportarSociosModal
          handleClose={e => setMostrarImportarSocios(false)}
          show={mostrarImportarSocios}
          reloadTable={tablaRef.current.reload} />
      )}
    </>
  )
}

export default ListaSociosPage
